import React, { useEffect, useState } from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import User from '../../models/User';
import Table from '../common/Table';
import TableEmailCell from '../common/TableEmailCell';
import StatusCell from './StatusCell';

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableCell-head': {
      paddingTop: 0,
    },
    borderRight: '1px solid #E7E7E7',
    marginTop: '1rem',
    width: '100%',
  },
}));
function getColumns(onInvitedClick) {
  return [
    { label: 'Name', name: 'name', sort: true },
    {
      label: 'Email Address',
      name: 'email',
      options: {
        customBodyRender: (value) => <TableEmailCell value={value} />,
      },
    },
    {
      label: 'Status',
      name: 'status',
      options: {
        customBodyRender: (value, meta) => {
          const creatorData = { email: meta.rowData[1], id: meta.rowData[3], name: meta.rowData[0], phoneNumber: meta.rowData[4] };
          return <StatusCell value={value} onInvitedClick={() => onInvitedClick(creatorData)} />;
        },
      },
    },
    {
      label: '',
      name: 'id',
      options: { display: false },
    },
    {
      label: '',
      name: 'phoneNumber',
      options: { display: false },
    },
  ];
}

export default ({ onInvitedClick, onInviteCreator, onCriteriaChange, creators, defaultData = new User(), total }) => {
  const classes = useStyles();
  const defaultOptions = {
    count: total,
    onTableChange: (action, tableState) => {
      const criteria = {};
      switch (action) {
        case 'sort':
          criteria.orderType = tableState.sortOrder.direction.toUpperCase();
          criteria.orderField = tableState.sortOrder.name;
          break;
        case 'changePage':
          criteria.page = tableState.page;
          break;
        case 'changeRowsPerPage':
          criteria.limit = tableState.rowsPerPage;
          setTableOptions({
            ...tableOptions,
            rowsPerPage: tableState.rowsPerPage,
          });
          break;
        default:
          return;
      }
      onCriteriaChange(criteria);
    },
    serverSide: true,
  };

  useEffect(() => {
    setTableOptions({
      ...tableOptions,
      count: total,
    });
  }, [total]);

  const columns = getColumns(onInvitedClick);
  const [tableOptions, setTableOptions] = useState(defaultOptions);
  return (
    <>
      <Typography variant="h5" align="left" style={{ paddingLeft: '8px' }} className="secondary-header">
        Creators
      </Typography>
      <Table className={`${classes.table} small-padding-table`} columns={columns} data={creators || []} options={tableOptions} />
    </>
  );
};
